import { Entry } from '../Entry'

export function Entry20220502() {
  return (
    <Entry title="02/05/2022 - v3.0.2">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12585/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
